const masks = {
    CPF: [/\d/, /\d/, /\d/,  '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/ ],
    DNI: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[A-Z]/ ],
    NIE: [/[XYZ]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[A-Z0-9]/, /[A-Z]/],
    CEP: [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
    codigoPostal: [/\d/, /\d/, /\d/, /\d/, /\d/],
};

export default masks;
